
import {Container} from "react-bootstrap";
import {useRef, useLayoutEffect, useState} from "react";
import {Link} from 'react-router-dom';
import {Img} from "../../components/UI/Img";
import CarouselCountContent from "../../components/UI/Carousel/CarouselCountContent";
import {useOutletContext } from "react-router-dom";
import './MainPage.scss';
import './media.scss';
import partner1 from '../../images/partner1.png'
import partner2 from '../../images/partner2.png';
import partner3 from '../../images/partner3.png';
import partner4 from '../../images/partner4.png';
import partner5 from '../../images/partner5.png';

const MainPage = () => {

    const factContainerHeight = useRef(null);
    const [currentActiveUrl, setCurrentActiveUrl] = useState(null)
    const [textCrew, setTextCrew] = useState({__html: ''})
    const [textAboutProject, setTextAboutProject] = useState({__html: ''})
    const [factheight, setFactheight] = useState(0);
    const itemWidth = useRef(null);
    const pageWidth = useRef(null);
    const [widthItem, setWidthItem] = useState(0);
    const [width, setWidth] = useState(0);
    const bannerHeight = useOutletContext();
    const [appState, setAppState] = useState({
        loading: false,
        repos: null,
      });

      const partners = [
        {src: partner1},
        {src: partner2},
        {src: partner5},
        {src: partner4},
        {src: partner3}
      ]
    
    useLayoutEffect(() => {
        setFactheight(factContainerHeight.current.offsetHeight);
        setWidth(pageWidth.current.offsetWidth);
        // setWidthItem(itemWidth.current.offsetWidth);
    }, []);

    useLayoutEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/getCurrentActiveFormUrl`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify('test'),
        }).then((response) => {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                setCurrentActiveUrl(data)
            });
            setAppState({ loading: false, repos: response});
        }).catch(function(error) {
            console.log(error)
        });
        fetch(`${process.env.REACT_APP_API_URL}/getTextByTitleAsHtml`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({title: 'О проекте', pageTitle: 'Главная'}),
        }).then((response) => {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                setTextAboutProject({__html: data.textContent})
            });
            setAppState({ loading: false, repos: response});
        }).catch(function(error) {
            console.log(error)
        });
        fetch(`${process.env.REACT_APP_API_URL}/getTextByTitleAsHtml`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({title: 'Команда', pageTitle: 'Главная'}),
        }).then((response) => {
            response.text().then(text => {
                const data = text && JSON.parse(text);
                setTextCrew({__html: data.textContent})
            });
            setAppState({ loading: false, repos: response});
        }).catch(function(error) {
            console.log(error)
        });
    }, [setAppState])
    
    return (
        <div className='main-page' ref={pageWidth}>
            <Container fluid className='banner' style={{height: window.innerHeight-bannerHeight+5+'px'}}>
                   <Link to={`forms/${currentActiveUrl}`} className='main-quote'>
                            Факторы риска
                            <br/> 
                            и новые вызовы 
                            <br/>
                            на пути достижения
                            <br/>
                            активного долголетия
                   </Link>
            </Container>
            <Container fluid className='content-text' id={'aboutproject'}>
                <div className='decorator'>
                    <Container className='block-title'>
                        <p>О проекте</p>
                    </Container>
                    <Container className='about'>
                        <div className='content-text__paragraf' dangerouslySetInnerHTML={textAboutProject}/>
                    </Container>
                </div>
            </Container>
            <Container fluid className='content-go'>
                <div className='local-title'>
                    Пройди анкету и помоги проекту!
                </div>
                <Link to={`forms/${currentActiveUrl}`} className='take-part--btn'>
                    Участвовать
                </Link>
            </Container>
            <Container fluid className='content-facts'>
                <div className='content-facts__container'>
                    <div className='content-facts__container__text' style={{height:factheight}}>
                        Окончательная дата:<span style={{color:'#E41D37'}}> среда, 01 марта 2023 г. </span>
                    </div>
                    <div className='content-facts__container__text' ref={factContainerHeight}>
                        Время, необходимое для ответов на вопросы:<span style={{color:'#E41D37'}}> примерно 20 минут</span>
                    </div>
                    <div className='content-facts__container__text' style={{height:factheight}}>
                        Приз: один из трёх сертификатов на <span style={{color:'#E41D37'}}>5000 ₽ </span>
                    </div>
                </div>
            </Container>
            <Container fluid className='content-text' id={'team'}>
                <div className='decorator'>
                    <Container className='block-title'>
                        <p>Команда</p>
                    </Container>
                    <Container className='about'>
                        <div className='content-text__paragraf' dangerouslySetInnerHTML={textCrew}/>
                    </Container>
                </div>
            </Container>
            {/* <Container fluid className='carousel-content' id={'info'}>
                <Container className='block-title'>
                    <p>Полезная информация</p>
                </Container>
                <div className='carousel-decorator' ref={itemWidth}>
                    <CarouselCountContent articles={articles} width={width} widthItem={widthItem}/>
                </div>
            </Container > */}
            <Container fluid className='content-text' id={'partners'}>
                <div className='decorator'>
                    <Container className='block-title'>
                        <p>Партнеры</p>
                    </Container>
                    <div className='content-text__partners'>
                    {partners.map((partner, i) => ( <Img key={i} src={partner.src} classes={['partner']}/>))}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default MainPage;